module.exports = __webpack_public_path__ + "img/image3.bdf9a97e.png";